import * as Yup from 'yup'
import {
  MAX_CHECKLIST_NAME_LENGTH,
  MAX_CHECKLIST_POINT_TEXT_LENGTH,
} from './constants'

export const checklistsValidationSchema = Yup.array().of(
  Yup.object({
    id: Yup.string(),

    __editing: Yup.boolean(),

    name: Yup.string()
      .trim()
      .max(
        MAX_CHECKLIST_NAME_LENGTH,
        `Название не должно превышать ${MAX_CHECKLIST_NAME_LENGTH} символов`
      )
      .when('__editing', {
        is: true,
        then: (schema) =>
          schema.test(
            'editing-still-on',
            'Завершите редактирование названия чек-листа',
            () => false
          ),
        otherwise: (schema) => schema.required('Нужно заполнить'),
      }),

    points: Yup.array()
      .of(
        Yup.object({
          id: Yup.string(),
          text: Yup.string()
            .trim()
            .max(
              MAX_CHECKLIST_POINT_TEXT_LENGTH,
              `Название не должно превышать ${MAX_CHECKLIST_POINT_TEXT_LENGTH} символов`
            )
            .required('Нужно заполнить'),
          is_done: Yup.boolean().required(),
        })
      )
      .required(),
  })
)
